export default "__VITE_ASSET__7lJwn9vx__"